export default "__VITE_ASSET__MEfU0kBI__"